import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UsuarioServiceProvider } from 'src/app/service/index.providers';

@Injectable({ providedIn: 'root' })
export class ReportsInAppGuard implements CanActivate {
  constructor(private router: Router,public up: UsuarioServiceProvider,) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let config_data = JSON.parse(this.up.getConfigData || 'null');
    const sideMenuAccess = config_data?.full_app_side_menu;

    const userDataString = localStorage.getItem("user_data");
    const userData = userDataString ? JSON.parse(userDataString) : null;
    if (sideMenuAccess?.reportes && userData?.supervisor) {
      return true;
    } else {
      // this.router.navigateByUrl(
      //   `/encuestas?api_url=${route.queryParams['api_url']}&poll_id=${route.queryParams['poll_id']}&entity_id=${route.queryParams['entity_id']}`
      // );
      this.router.navigate([""]);
      return false;
    }
  }
}
